export default {
      id: "i-safe-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-safe",
      toString: function () {
        return this.url;
      }
    }